module.exports = __webpack_public_path__ + "static/media/importICloud1.93d784ce.png";